import { ToastContainer } from 'react-toastify';
import './App.css';
import RoutingModule from './RoutingModule';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
  <>
    <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_API_KEY}`}>
      <RoutingModule />
    </GoogleOAuthProvider>
    <ToastContainer />
  </>
  );
}

export default App;
